import {
  BroadbandMatchRequestResponse_Status,
  BroadbandSwitchingOptionService_Action,
} from '@generated/gql/graphql';

export interface IOTSData {
  currentAddress: IOTSAddress;
  hasExistingLine: boolean;
  providerNotListed: boolean;
  selectedProvider: IOTSProvider | null;
  findStatus: FindStatus;
  comms: IOTSCommunication[];
  homePhoneSuffix: string | null;
  orderType: OrderType;
  numberToPort: string | null;
  surname: string;
  accountReference?: string;
  broadbandReference?: string;
  homePhoneReference?: string;
  fieldErrors: string[];
  canSubmit: boolean;
  matchId: string | null;
  switchingReference: string | null;
  switchOptions: IOTSSwitchOption[];
}

export interface IOTSAddress {
  addressLines: string[];
  postCode: string;
  postTown: string;
  uprn?: string;
}

export enum OrderType {
  BROADBAND_ONLY = 'BROADBAND_ONLY',
  BROADBAND_AND_VOICE = 'BROADBAND_AND_VOICE',
}

export enum FindStatus {
  NOT_STARTED = 'NOT_STARTED',
  FINDING = 'FINDING',
  FOUND = 'FOUND', // match success, modal open
  SUCCESS = 'SUCCESS', // match success, modal closed
  NOT_FOUND = 'NOT_FOUND', // not found, can retry
  FAIL = 'FAIL', // not found, cannot retry
}

export const OTSMatchStatus = BroadbandMatchRequestResponse_Status;
export const OTSServiceAction = BroadbandSwitchingOptionService_Action;

export interface IOTSProvider {
  id: string;
  name: string;
}

export interface IOTSCommunication {
  name: string;
  value: string | null;
}

export interface IOTSSwitchOption {
  switchingReference: string;
  broadbandAction: BroadbandSwitchingOptionService_Action;
  homePhoneAction: BroadbandSwitchingOptionService_Action;
}
